import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../containers/Text';
import './HomePage.scss';

const WelcomeSection = () => {
  const { i18n, t } = useTranslation();

  return (
    <section className="welcome-section">
      <h2 className={`welcome-title ${i18n.language === 'heb' ? 'lng-heb' : 'lng-en'}`}>
        {t('welcome-title')}
      </h2>
      <div className={`welcome-description ${i18n.language === 'heb' ? 'lng-heb' : 'lng-en'}`}>
        <p>
          {t('welcome-description1')}
          <br />
          {t('welcome-description2')}
        </p>
      </div>
    </section>
  );
};

export default WelcomeSection;
